"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Uploads = /** @class */ (function () {
    function Uploads(dialog, Upload, config, $timeout, $interpolate) {
        this.dialog = dialog;
        this.Upload = Upload;
        this.config = config;
        this.$timeout = $timeout;
        this.$interpolate = $interpolate;
        this.options = {};
        this.uploads = config.uploads || [];
        this.path = config.params.upload;
        this.current = {
            state: 'idle',
            dataUrl: undefined,
            option: null
        };
    }
    Uploads.prototype.prepare = function (prepare) {
        if (prepare === void 0) { prepare = true; }
        this.setState(prepare ? 'preparing' : 'idle');
    };
    Uploads.prototype.setOption = function (prefix, id, option) {
        if (typeof this.options[prefix] === 'undefined') {
            this.options[prefix] = {};
        }
        this.options[prefix][id] = Object.assign({ prefix: prefix, id: id }, option);
    };
    Uploads.prototype.getUpload = function (option) {
        var upload = this.uploads.find(function (upload) { return upload.option === option; });
        return upload;
    };
    Uploads.prototype.getUploads = function () {
        return this.uploads;
    };
    Uploads.prototype.setUpload = function (upload) {
        var index = this.uploads.findIndex(function (index) { return index.option === upload.option; });
        if (index >= 0) {
            this.uploads[index] = upload;
        }
        else {
            this.uploads.push(upload);
        }
    };
    Uploads.prototype.resetUpload = function (option) {
        var index = this.uploads.findIndex(function (index) { return index.option === option; });
        if (index >= 0) {
            this.uploads.splice(index, 1);
        }
    };
    Uploads.prototype.getThumbnail = function (option) {
        var upload = this.getUpload(option);
        return upload ? upload.thumb : undefined;
    };
    Uploads.prototype.getCurrentOption = function () {
        return this.current.option || {};
    };
    Uploads.prototype.isCropable = function () {
        if (this.current.option && !this.current.option.gmStaticOptions) {
            return true;
        }
        return false;
    };
    Uploads.prototype.setFileRef = function (prefix, id, file, cropable) {
        var _this = this;
        if (cropable === void 0) { cropable = true; }
        this.setState('preparing');
        var option = this.options[prefix][id];
        if (!cropable) {
            this.setCurrentOption(option, file);
        }
        else if (this.checkFileSize(file, option)) {
            var reader = new FileReader();
            reader.onload = function (evt) {
                var dataUrl = evt.target.result;
                _this.checkFileDimensions(option, dataUrl);
            };
            reader.readAsDataURL(file);
        }
    };
    Uploads.prototype.uploadImage = function (dataUrl) {
        var that = this;
        var upload = this.getUpload(this.current.option.prefix + "." + this.current.option.id);
        var previousID = upload ? upload.id : undefined;
        this.setState('loading');
        this.current.dataUrl = dataUrl;
        this.Upload.upload({
            url: this.path,
            data: {
                'image': dataUrl,
                'thumbSize': 300,
                'previousImageID': previousID
            }
        }).then(function (resp) {
            console.log(['Upload successful', resp]);
            if (!resp.data.hasOwnProperty('error') || resp.data.error === 0) {
                if (resp.data.hasOwnProperty('imageID') &&
                    resp.data.hasOwnProperty('imageName') &&
                    resp.data.hasOwnProperty('thumbPath')) {
                    that.onUploadCompleted(resp.data.imageID, resp.data.imageName, resp.data.thumbPath);
                }
                else {
                    that.showUploadError(that.config.localeJson.ui.dialogs.photoUploadServerError.title, that.config.localeJson.ui.dialogs.photoUploadServerError.text, that.config.localeJson.ui.dialogs.photoUploadServerError.button.ok, undefined);
                }
            }
            else {
                that.showUploadError(that.config.localeJson.ui.dialogs.photoUploadServerError.title, resp.data.errorMessage, that.config.localeJson.ui.dialogs.photoUploadServerError.button.ok, resp.data.error);
            }
        }, function (resp) {
            // Handle error.
            console.log(['Upload error', resp]);
            that.showUploadError(that.config.localeJson.ui.dialogs.photoUploadServerError.title, resp.statusText, that.config.localeJson.ui.dialogs.photoUploadServerError.button.ok, resp.status);
        }, function (evt) {
            // TODO: Display upload progress
            console.log(['Upload progress', evt.loaded]);
        });
    };
    Uploads.prototype.onUploadCompleted = function (id, name, thumb) {
        this.setState('idle');
        var option = this.current.option;
        var upload = {
            option: option.prefix + "." + option.id,
            id: id,
            name: name,
            thumb: thumb
        };
        this.setUpload(upload);
    };
    Uploads.prototype.cancel = function () {
        this.setState('idle');
    };
    Uploads.prototype.showUploadError = function (title, message, button, code) {
        this.setState('idle');
        message = message || '';
        title = title || this.config.localeJson.ui.dialogs.photoUploadServerError.title;
        button = button || 'OK';
        message = code ? 'Error ' + code + ': ' + message : message;
        this.dialog.show(message, {
            title: title,
            buttons: [{ label: button }]
        });
    };
    Uploads.prototype.setState = function (state) {
        this.current.state = state;
    };
    Uploads.prototype.setCurrentOption = function (option, dataUrl) {
        this.current.option = option;
        this.current.dataUrl = dataUrl;
    };
    Uploads.prototype.checkFileSize = function (file, option) {
        var fileSizeExceeded = !(!option.maxkb || option.maxkb * 1024 > file.size);
        if (fileSizeExceeded) {
            this.setState('idle');
            var maxkb = option.maxkb < 1024 ?
                option.maxkb + ' KB' :
                Math.round(option.maxkb / 1024 * 10) / 10 + ' MB';
            this.dialog.show(this.$interpolate(this.config.localeJson.ui.dialogs.photoUploadMaxSize.text)({ maxkb: maxkb }), {
                title: this.config.localeJson.ui.dialogs.photoUploadMaxSize.title,
                buttons: [{ label: this.config.localeJson.ui.dialogs.photoUploadMaxSize.button.ok }]
            });
        }
        return !fileSizeExceeded;
    };
    Uploads.prototype.checkFileDimensions = function (option, dataUrl, timeout) {
        timeout = timeout || 10000;
        var img = new Image(), fileSizeUndercut, that = this, timer;
        img.onload = function () {
            clearTimeout(timer);
            that.$timeout(function () {
                fileSizeUndercut = img.width < option.width || img.height < option.height;
                if (fileSizeUndercut) {
                    that.current.state = 'idle';
                    that.dialog.show(that.$interpolate(that.config.localeJson.ui.dialogs.photoUploadMinSize.text)({
                        height: Math.round(option.height),
                        width: Math.round(option.width)
                    }), {
                        title: that.config.localeJson.ui.dialogs.photoUploadMinSize.title,
                        buttons: [{ label: that.config.localeJson.ui.dialogs.photoUploadMinSize.button.ok }]
                    });
                }
                else {
                    that.current.option = option;
                    that.current.dataUrl = dataUrl;
                    that.setState('crop');
                }
            });
        };
        img.onerror = function () {
            clearTimeout(timer);
            that.onImageError();
        };
        timer = setTimeout(function () { that.onImageError(); console.log('timeout'); }, timeout);
        img.src = dataUrl;
    };
    Uploads.prototype.onImageError = function () {
        var that = this;
        that.$timeout(function () {
            that.current.state = 'idle';
            that.dialog.show(that.config.localeJson.ui.dialogs.photoUploadNoImage.text, {
                title: that.config.localeJson.ui.dialogs.photoUploadNoImage.title,
                buttons: [{ label: that.config.localeJson.ui.dialogs.photoUploadNoImage.button.ok }]
            });
        });
    };
    return Uploads;
}());
exports.default = angular.module('pb.uploads', [])
    .service('uploads', Uploads);
